import script from "./HotSpotDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HotSpotDetailPanel.vue?vue&type=script&setup=true&lang=js"

import "./HotSpotDetailPanel.vue?vue&type=style&index=0&id=0c9a27ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9a27ea"]])

export default __exports__